import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Input = styled.input `
  opacity: 0;
  position: absolute;
  pointer-events: none;
  width: ${pxToRem(1)};
  height: ${pxToRem(1)};
`;
